import './Dyno.css';
import RightArrow from '../../images/right-arrow.svg';
import DynoFeature from '../../images/dyno-feature.png';

const Dyno = () => {
  return (
    <div className="dyno-container" id="dyno-section">
      <div className="dyno-columns">
        <div className="dyno-left-column">
          <div className="dyno-row">
            <span className="dyno-text">Dyno</span>
            <span className="dyno-description"> creates bulk discount codes quickly and easily. Generate unlimited unique codes or import from a CSV file with our intuitive interface.</span>
          </div>
          <div className="dyno-second-row">

          </div>
          <div className="dyno-second-row">
            <span className="dyno-text-secondary">Dyno allows you to customize your discount codes to your liking with a variety of options. Whether it's a percentage or fixed amount, Dyno has you covered.</span>
            <button className="dyno-button" onClick={() => {
              window.open('https://apps.shopify.com/dyno-bulk-discount-code-generator', '_blank');
            }}>
              <div className="dyno-button-text">Get started</div>
              <img src={RightArrow} alt="right arrow" className="arrow-icon" />
            </button>
          </div>
        </div>
        <div className="dyno-right-column">
          <div className="dyno-feature-table-wrapper">
            <table className="dyno-feature-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Status</th>
                  <th>Method</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Christmass 5% Off Everything</td>
                  <td><span className="dyno-status-generated">Active</span></td>
                  <td>200,000 codes</td>
                </tr>
                <tr>
                  <td>Stolen Package Codes</td>
                  <td><span className="dyno-status-generated">Active</span></td>
                  <td>500 codes</td>
                </tr>
                <tr>
                  <td>Recover Card Marketing Codes</td>
                  <td><span className="dyno-status-generated">Active</span></td>
                  <td>10,000 codes</td>
                </tr>
                <tr>
                  <td>Staff / Employee Codes</td>
                  <td><span className="dyno-status-generated">Active</span></td>
                  <td>1,000 codes</td>
                </tr>
                <tr>
                  <td>G2R Email Campaign</td>
                  <td><span className="dyno-status-generated">Active</span></td>
                  <td>500,000 codes</td>
                </tr>
                <tr>
                  <td>Halloween $5 All Codes</td>
                  <td><span className="dyno-status-generated">Active</span></td>
                  <td>30,000 codes</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Discount Code Generator UI - stacked below the table in the right column */}
          <div className="dyno-codegen-wrapper">
            <div className="dyno-codegen-box">
              <div className="dyno-codegen-title">Discount codes</div>
              <div className="dyno-codegen-row">
                <div className="dyno-codegen-field">
                  <label>Number of codes to generate</label>
                  <input type="number" value="250" readOnly />
                </div>
                <div className="dyno-codegen-field">
                  <label>Length of codes</label>
                  <input type="number" value="6" readOnly />
                </div>
              </div>
              <div className="dyno-codegen-row">
                <div className="dyno-codegen-field">
                  <label>Prefix</label>
                  <input type="text" value="MOM-" readOnly />
                </div>
                <div className="dyno-codegen-field">
                  <label>Suffix</label>
                  <input type="text" value="-20" readOnly />
                </div>
              </div>
              <div className="dyno-codegen-allowed">
                <div className="dyno-codegen-allowed-title">Allowed characters</div>
                <div className="dyno-codegen-checkboxes">
                  <label className="dyno-checkbox-label">
                    <input type="checkbox" checked readOnly /> Allow letters
                  </label>
                  <label className="dyno-checkbox-label">
                    <input type="checkbox" checked readOnly /> Allow numbers
                  </label>
                </div>
              </div>
              <div className="dyno-codegen-sample-title">Sample discount code</div>
              <input className="dyno-codegen-sample" type="text" value="MOM-L8L0OM-20" readOnly />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dyno;